var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixRestaurantsPostpaapiV1Configuration from '@wix/ambassador-restaurants-postpaapi-v1-configuration/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
const _disconnectAccountRequest = {};
const _disconnectAccountResponse = {};
const _disconnectConfigurationRequest = {};
const _disconnectConfigurationResponse = {};
const _getConfigurationRequest = {};
const _getConfigurationResponse = {};
const _listConfigurationsRequest = {};
const _listConfigurationsResponse = {};
/**
 * This endpoint gets a location configuration by ID on the Wix site.
 * @param _id - Configuration ID.
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @returns The merchant's location configuration on Wix.
 */
export function getConfiguration(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$.configuration';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getConfigurationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getConfigurationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['configuration']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixRestaurantsPostpaapiV1Configuration.getConfiguration(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * This endpoint retrieves a list of location configurations on the Wix site.
 * @internal
 * @documentationMaturity preview
 */
export function listConfigurations() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listConfigurationsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listConfigurationsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#configurations']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixRestaurantsPostpaapiV1Configuration.listConfigurations(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * This endpoint disconnects the account between the merchant and the POS service provider.
 *
 * The account is not deleted. You can reconnect to the account using the POS integration settings in the Dashboard.
 *
 * Call the [List Account IDs](https://dev.wix.com/api/rest/wix-restaurants/point-of-sale-integration/pos-connectivity-spi/list-account-ids) SPI endpoint to retrieve a list of existing account IDs.
 * @param accountId - The ID for the account between the merchant and the POS service provider.
 * @internal
 * @documentationMaturity preview
 * @requiredField accountId
 * @adminMethod
 */
export function disconnectAccount(accountId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            accountId: '$[0]',
            appDefId: '$[1].appDefId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _disconnectAccountRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _disconnectAccountResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([accountId, options]);
        const reqOpts = ambassadorWixRestaurantsPostpaapiV1Configuration.disconnectAccount(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'accountId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * This endpoint disconnects the Wix location configuration from a POS service provider's location.
 *
 * The configuration is not deleted. You can reconnect to the configuration using the POS integration settings in the Dashboard.
 *
 * Call the [List Configurations](https://dev.wix.com/api/rest/wix-restaurants/point-of-sale-integration/pos-connectivity-api/list-configurations) SPI endpoint to retrieve a list of existing configuration IDs.
 * @param configurationId - The ID of the merchant's location configuration on Wix.
 * @internal
 * @documentationMaturity preview
 * @requiredField configurationId
 * @adminMethod
 */
export function disconnectConfiguration(configurationId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { configurationId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _disconnectConfigurationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _disconnectConfigurationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([configurationId]);
        const reqOpts = ambassadorWixRestaurantsPostpaapiV1Configuration.disconnectConfiguration(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'configurationId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=restaurants-postpaapi-v1-configuration.universal.js.map